/**
 * ANQ.ContentServiceManagement.API 
 * Content Service Mgt API
 *
 * OpenAPI spec version: v1
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { EntityStatus } from './entityStatus';

export interface HubService { 
    _id?: string;
    id?: number;
    serviceName?: string;
    systemName?: string;
    status?: EntityStatus;
    balance?: number;
    serviceId?: string;
    owner?: string;
    ownerId?: number;
    channel?: string;
    industry?: number;
    category?: number;
    categoryCode?: string;
    shortCode?: string;
    keyword?: string;
    expiryDate?: Date;
    activeDate?: Date;
    serviceCode?: string;
    price?: number;
    serviceProviderId?: string;
    subscriptionType?: number;
    periodicity?: number;
    frequency?: number;
    serviceStatus?: number;
    operatorIds?: string;
    serviceProviderName?: string;
    isVasSystemService?: boolean;
    vasSystemServiceCode?: string;
}